import { render, staticRenderFns } from "./AgriculturalRank.vue?vue&type=template&id=41030358&scoped=true"
import script from "./AgriculturalRank.vue?vue&type=script&lang=js"
export * from "./AgriculturalRank.vue?vue&type=script&lang=js"
import style0 from "./AgriculturalRank.vue?vue&type=style&index=0&id=41030358&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41030358",
  null
  
)

export default component.exports